export default {
    packages_features_title: "Características",
    packages_features_success_message: "Se han actualizado las características",
    packages_features_error_message: "No ha sido posible actualizar las características debido a un error",
    packages_features_feature_name: "Nombre de la característica",
    packages_features_feature_key: "Clave de características",
    packages_features_read: "Leer",
    packages_features_create: "Crear",
    packages_features_update: "Actualizar",
    packages_features_delete: "Eliminar",
    packages_features_optional: "Opcional",
    packages_features_default: "Por defecto",
    packages_features_save_changes: "Guardar cambios",
    packages_features_all: "Todo",
    packages_features_the_feature_mush_have_the_read: "La caracteristica debe tener marcado el permiso de lectura",
    packages_features_all_features_must_have_read_permission_check: "Todas las caracteristicas deben tener marcado el permiso de lectura",
    packages_features_group_name: "Nombre del grupo",
    packages_features_category: "Categoría",
    packages_features_main_feature_read_perm: "La función principal debe tener permisos de lectura",
    packages_features_main_feature_create_perm: "La función principal debe tener permisos de creación",
    packages_features_main_feature_update_perm: "La función principal debe tener permisos de actualización",
    packages_features_main_feature_delete_perm: "La función principal debe tener permisos de eliminación",
    packages_features_the_group_must_be_included: "El grupo debe estar incluido",
    packages_features_group: "Grupo",
    packages_features_included: "Incluye",
    packages_features_code: "Código",
    packages_features_description: "Descripción",
    packages_features_active: "Activo",
}